module.exports = __webpack_public_path__ + "img/activity-boat.ce296619.jpg";